export default "__VITE_ASSET__qlRSQVEpG32EN$mQwkO1hg__"